var _defs, _circle, _path, _circle2, _circle3, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterrupt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 5.914,
    cy: 28.524,
    r: 1.399
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M8.574 24.42l2.652-4.22h12.889l4.693 4.613 9.197 2.367v6.156H34.07M25.978 33.336H17.99M11.165 33.336H5.914"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_sub",
    cx: 14.578,
    cy: 34.079,
    r: 3.413
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_sub",
    cx: 29.76,
    cy: 34.079,
    r: 3.413
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M34.775 6.991l-7.91 7.91M26.865 6.991l7.91 7.91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterrupt);
export default __webpack_public_path__ + "static/media/interrupt.05f01debff4f772438606f3dd39f5ff3.svg";
export { ForwardRef as ReactComponent };